import gql from 'graphql-tag'

export default gql`
  mutation UpdateCartItem($input: EditProductInput!) {
    updateCartItem(input: $input) {
      ... on Cart {
        id
        items {
          id
          sku
          name
          salesPrice
          quantity
          image {
            url
            description
          }
          ... on GenericCartItem {
            listPrice
            options {
              name
              value
            }
          }
        }
      }
      ... on Error {
        message
      }
    }
  }
`
